module.exports = __webpack_public_path__ + "media/images/date_range-24px-50da5d756595cc654cc920f82bc7f546.svg";